import ReactTooltip from 'react-tooltip';
import { useEffect, useState } from 'react';
import { GetMonitors } from '../common/uptimerobot';
import { formatDuration, formatNumber } from '../common/helper';
import Link from './link';

function UptimeRobot({ apiConfig }) {

  const status = {
    ok: 'Operational',
    down: 'Down',
    unknow: 'Unknown'
  };

  const { CountDays, ShowLink } = window.Config;
  const { key: apikey, name: customName, link: customLink } = apiConfig;

  const [monitors, setMonitors] = useState();

  useEffect(() => {
    GetMonitors(apikey, CountDays).then(setMonitors);
  }, [apikey, CountDays]);

  if (monitors) return monitors.map((site) => {
    // Use custom name and link if provided, otherwise fall back to UptimeRobot values
    const displayName = customName || site.name;
    const displayUrl = customLink || site.url;

    return (
      <div key={site.id} className='site'>
        <div className='meta'>
          <span className='name' dangerouslySetInnerHTML={{ __html: displayName }} />
          {ShowLink && <Link className='link' to={displayUrl} text={displayName} />}
          <span className={'status ' + site.status}>{status[site.status]}</span>
        </div>
        <div className='timeline'>
          {site.daily.map((data, index) => {
            let status = '';
            let text = data.date.format('YYYY-MM-DD ');
            if (data.uptime >= 100) {
              status = 'ok';
              text += `Uptime ${formatNumber(data.uptime)}%`;
            }
            else if (data.uptime <= 0 && data.down.times === 0) {
              status = 'none';
              text += 'No data';
            }
            else {
              status = 'down';
              text += `${data.down.times} outage(s), total ${formatDuration(data.down.duration)}, uptime ${formatNumber(data.uptime)}%`;
            }
            return (<i key={index} className={status} data-tip={text} />)
          })}
        </div>
        <div className='summary'>
          <span>Today</span>
          <span>
            {site.total.times
              ? `Last ${CountDays} days: ${site.total.times} outage(s), total ${formatDuration(site.total.duration)}, average uptime ${site.average}%`
              : `Last ${CountDays} days: uptime ${site.average}%`}
          </span>
          <span>{site.daily[site.daily.length - 1].date.format('YYYY-MM-DD')}</span>
        </div>
        <ReactTooltip className='tooltip' place='top' type='dark' effect='solid' />
      </div>
    );
  });

  else return (
    <div className='site'>
      <div className='loading' />
    </div>
  );
}

export default UptimeRobot;
